import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, PlayIcon } from 'lucide-react';
interface ExitIntentModalProps {
  open: boolean;
  monthlyUrl: string;
  annualUrl: string;
  onClose: () => void;
  onMonthlyClick: () => void;
  onAnnualClick: () => void;
}
export function ExitIntentModal({
  open,
  monthlyUrl,
  annualUrl,
  onClose,
  onMonthlyClick,
  onAnnualClick
}: ExitIntentModalProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-137" data-mp="19bs41tviwwbg">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: 'easeOut'
    }} className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 px-4" onClick={onClose} data-id="element-138" data-mp="1e9tmqdp1etme">
          <motion.div role="dialog" aria-modal="true" aria-labelledby="exit-intent-title" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={event => event.stopPropagation()} className="relative w-full max-w-lg overflow-hidden rounded-lg bg-[#181818] shadow-2xl" data-id="element-139" data-mp="1oqqxpyz4su9h">
            <button ref={closeButtonRef} type="button" onClick={onClose} aria-label="Cerrar" className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-black/60 text-white transition-colors hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-140" data-mp="1e4qz9nerfwz3">
              <XIcon className="h-5 w-5" data-id="element-141" data-mp="ve9d61ofnzmp" />
            </button>

            <div className="h-1.5 w-full bg-[#E50914]" data-id="element-142" data-mp="vfu3tg7mmyfa" />

            <div className="px-6 py-8 md:px-10 md:py-10 text-center" data-id="element-143" data-mp="zfcrukuqvpmc">
              <p className="mb-3 text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-white/60" data-id="element-144" data-mp="zdi8haz4g5kd">
                Antes de irte
              </p>
              <h2 id="exit-intent-title" className="mb-3 font-sans text-2xl md:text-3xl font-bold uppercase leading-tight text-white" data-id="element-145" data-mp="196ftbnrl66m5">
                Acceder Ahora con{' '}
                <span className="underline decoration-[#E50914] decoration-4 underline-offset-4" data-id="element-146" data-mp="gnk0euvbqcgq">
                  Descuento
                </span>{' '}
                a La Academia de Bienes Raíces
              </h2>
              <p className="mb-6 text-base text-white/70" data-id="element-147" data-mp="44y4yj3rtaq5">
                Aprovéchalo por{' '}
                <span className="font-bold text-white" data-id="element-148" data-mp="3vewtoxrjo3oa">$37 USD</span> mensuales.
              </p>

              <a href={monthlyUrl} target="_blank" rel="noopener noreferrer" onClick={onMonthlyClick} className="inline-flex w-full items-center justify-center gap-2 rounded bg-[#E50914] px-6 py-4 text-base font-bold text-white transition-colors hover:bg-[#C40812] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#181818]" data-id="element-149" data-mp="3rdtbi4m0xvjw">
                <PlayIcon className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-150" data-mp="33nyynn1pg6zn" />
                Me interesa por $37 USD
              </a>

              <a href={annualUrl} target="_blank" rel="noopener noreferrer" onClick={onAnnualClick} className="mt-4 inline-block text-sm font-semibold text-white/70 underline-offset-4 transition-colors hover:text-white hover:underline" data-id="element-151" data-mp="12j4zb0mo5t5r">
                Prefiero el Plan Anual de $197 USD
              </a>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}